export const saveOrderFlowData = (orderFlowData) => {
  return (dispatch, getState, { api }) => {
    return api.saveOrderFlowData(orderFlowData).then(
      (data) => {
        return true;
      },
      (err) => {
        return false;
      },
    );
  };
};
